module.exports = __webpack_public_path__ + "img/yggl.4d39b6b4.png";